module.exports = __webpack_public_path__ + "b5de6dd0b66c8117a5c02e8c4354aff8.svg";